import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';
import { TierGateContext } from './TierGateContext';
import { useFetch } from '@/shared/hooks/useFetch/useFetch';
import type { TierGatesMap } from '@/interfaces/api/tierGates';

interface ApiResponse {
  data: TierGatesMap;
}

const TierGateProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { data, error, isLoading, mutate } = useFetch<ApiResponse>({
    url: '/v1/b2b/tier/gates',
    requiresAuth: true,
  });

  const value = useMemo(
    () => ({
      gates: data?.data ?? {},
      isLoading,
      error,
      refresh: () => {
        mutate();
      },
    }),
    [data, isLoading, error, mutate]
  );

  return <TierGateContext.Provider value={value}>{children}</TierGateContext.Provider>;
};

export default TierGateProvider;
